
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IWykrojnikRow } from "./IWykrojnikRow";
import { WykrojnikSvc } from "./WykrojnikSvc";

@Component({ components: {} })
export default class WykrojnikSelectedVue extends Vue {
  @Prop(String) tree_id: any;
  @Prop(Number) naklad!: number;
  @Prop(String) title!:string;

  w: IWykrojnikRow | undefined;
  key: number = 0;
  ilosc_etykiet:number=0;

  surowiec:string=""
  podklad:string=""

  async mounted() {
    this.ilosc_etykiet=0
    const w = await new WykrojnikSvc().get_selected_wykrojnik_for_tree(
      this.tree_id
    );

    if (w && w._id) {
      this.w = w;
      if (w.ux && w.uy) {
        this.ilosc_etykiet = w.ux*w.uy
      }


        this.surowiec=""
        this.podklad = ""

        if(w.w23_mat_wie_pap=='TAK') this.surowiec+="PAPIER "
        if(w.w24_mat_wie_fol=='TAK') this.surowiec+="FOLIA "
        if(w.w25_podklad_pap=='TAK') this.podklad+="papier "
        if(w.w26_podklad_fol=='TAK') this.podklad+="folia "
        if(w.w27_podklad_iml=='TAK') this.podklad+=" IML"



      this.key++;
    } else {
      this.w = undefined;
      this.key = 0;
    }
  }
}
